export default __webpack_public_path__ + "static/media/background-popup2.f316666f.png";